"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const e="0.77.5";exports.version=e;
